<template>
	<PopupBase
		:open="isPopupOpen"
		@closePopup="closePopup"
		:overlay-color="props.overlayColor"
		:overlay-max-opacity="props.overlayMaxOpacity"
		:styleTop="'25%'">
		<slot></slot>
		<!-- Content will be injected here -->
	</PopupBase>
</template>

<script setup lang="ts">
import { ref, defineProps } from "vue"
import PopupBase from "@/vue/common/popupBase.vue"

// Props
interface Props {
	overlayColor: string
	overlayMaxOpacity: number
	top?: string
}

const props = defineProps<Props>()

// Refs
const isPopupOpen = ref<boolean>(false)

function openPopup(): void {
	isPopupOpen.value = true
}

function closePopup(): void {
	isPopupOpen.value = false
}

// Exposing functions using defineExpose
defineExpose({
	openPopup,
	closePopup,
})
</script>
